import { jsx as _jsx } from "react/jsx-runtime";
export const createIcon = (svgContent, viewBox = '0 0 24 24') => {
    return ({ size = 24, width, height, ref, ...props }) => {
        const resolvedSize = width || height ? undefined : size;
        return (_jsx("svg", { fill: "none", role: "graphics-symbol", width: width || resolvedSize, height: height || resolvedSize, viewBox: viewBox, xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: svgContent }));
    };
};
//# sourceMappingURL=create-icon.js.map